import { DEFAULT_ANIMATE_SHORT_DURATION } from '@apeiron/temp'
import {
  Box,
  styled,
  Switch as MuiSwitch,
  SwitchProps,
  Typography
} from '@mui/material'
import * as R from 'ramda'
import { FC } from 'react'
import { Control, useController } from 'react-hook-form'

const Container = styled(Box)`
  align-items: center;
  display: flex;
  gap: 20px;
`

const Label = styled(Typography)`
  color: white;
  font-size: 16px;
  font-weight: 300;
  line-height: 16px;
  margin-top: 2px;
`

const DefaultSwitch = styled(MuiSwitch)`
  width: 38px;
  height: 20px;
  padding: unset;
  .MuiSwitch-switchBase {
    padding: 3px;
    &.Mui-checked {
      + .MuiSwitch-track {
        opacity: 1;
        background-color: #02ff1b;
      }
      .MuiSwitch-thumb {
        transform: translateX(-3px); // this is toggle ON offset
        background-color: #ffffff;
        border: 1px solid #949494;
        box-shadow: none;
      }
    }
  }
  .MuiSwitch-thumb {
    width: 14px;
    height: 14px;
    border-radius: 999px;
    transition: ${DEFAULT_ANIMATE_SHORT_DURATION}ms;
    background-color: #3d3d3d;
  }
  .MuiSwitch-track {
    border-radius: 10px;
    opacity: 1;
    background-color: #b9bfc9;
  }
`

const HookSwitch: FC<HookSwitchProps> = props => {
  const { hook, ...rest } = props

  const { control, name } = hook

  const { field } = useController({ control, name })

  return <DefaultSwitch {...rest} {...field} />
}

const ApeironSwitch: FC<Props> = props => {
  const { className, label, hook, ...rest } = props

  const isHook = R.isNotNil(hook)

  const Switch = isHook ? (
    <HookSwitch {...rest} hook={hook} />
  ) : (
    <DefaultSwitch {...rest} />
  )

  return label ? (
    <Container className={className}>
      <Label>{label}</Label>
      {Switch}
    </Container>
  ) : (
    Switch
  )
}

type HookProps = {
  control: Control<any>
  name: string
}

type HookSwitchProps = SwitchProps & {
  hook: HookProps
}

type Props = SwitchProps & {
  className?: string
  label?: string
  hook?: HookProps
}

export default ApeironSwitch
